var _g, _g2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAboutSoftwareBg(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "1520px",
    height: "792.455px",
    viewBox: "0 0 1520 792.455",
    enableBackground: "new 0 0 1520 792.455",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    fill: "#1B75BB",
    cx: 178.453,
    cy: 221.416,
    r: 5.509
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#1B75BB",
    cx: 79.785,
    cy: 306.305,
    r: 5.509
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#1B75BB",
    cx: 257.163,
    cy: 308.484,
    r: 5.509
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1B75BB",
    d: "M130.785,372.038c0,3.042-2.467,5.509-5.509,5.509s-5.509-2.467-5.509-5.509 c0-3.046,2.467-5.513,5.509-5.513S130.785,368.992,130.785,372.038z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1B75BB",
    d: "M140.312,496.097c0,3.042-2.467,5.51-5.509,5.51c-3.046,0-5.509-2.468-5.509-5.51s2.463-5.509,5.509-5.509 C137.845,490.588,140.312,493.055,140.312,496.097z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#1B75BB",
    cx: 254.299,
    cy: 604.993,
    r: 5.509
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#1B75BB",
    cx: 78.904,
    cy: 498.354,
    r: 5.509
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#1B75BB",
    cx: 255.642,
    cy: 401.155,
    r: 5.509
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1B75BB",
    d: "M200.311,304.045c0,3.042-2.467,5.509-5.509,5.509c-3.046,0-5.509-2.467-5.509-5.509 c0-3.046,2.463-5.51,5.509-5.51C197.844,298.535,200.311,300.999,200.311,304.045z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#1B75BB",
    cx: 197.11,
    cy: 553.229,
    r: 5.511
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#1B75BB",
    cx: 393.626,
    cy: 262.73,
    r: 2.816
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#1B75BB",
    cx: 328.213,
    cy: 233.089,
    r: 2.816
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#1B75BB",
    cx: 277.326,
    cy: 206.334,
    r: 2.814
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#1B75BB",
    cx: 408.934,
    cy: 299.795,
    r: 2.816
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1B75BB",
    d: "M419.377,321.012c0,1.554-1.259,2.816-2.813,2.816c-1.558,0-2.82-1.263-2.82-2.816s1.263-2.816,2.82-2.816 C418.118,318.195,419.377,319.458,419.377,321.012z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#1B75BB",
    cx: 443.266,
    cy: 407.796,
    r: 2.816
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1B75BB",
    d: "M433.558,443.819c0,1.554-1.263,2.813-2.816,2.813c-1.558,0-2.816-1.259-2.816-2.813 c0-1.558,1.259-2.816,2.816-2.816C432.295,441.003,433.558,442.262,433.558,443.819z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#1B75BB",
    cx: 404.473,
    cy: 484.053,
    r: 2.816
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#1B75BB",
    cx: 383.201,
    cy: 536.793,
    r: 2.816
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#1B75BB",
    cx: 337.151,
    cy: 583.969,
    r: 2.815
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1B75BB",
    d: "M310.47,565.313c0,1.554-1.259,2.816-2.816,2.816c-1.554,0-2.813-1.263-2.813-2.816 c0-1.558,1.259-2.816,2.813-2.816C309.211,562.497,310.47,563.756,310.47,565.313z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#1B75BB",
    cx: 277.246,
    cy: 598.724,
    r: 2.814
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1B75BB",
    d: "M395.471,401.617c0,1.558-1.259,2.816-2.813,2.816c-1.558,0-2.816-1.259-2.816-2.816 c0-1.554,1.259-2.816,2.816-2.816C394.212,398.801,395.471,400.063,395.471,401.617z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#1B75BB",
    cx: 319.698,
    cy: 522.536,
    r: 2.816
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1B75BB",
    d: "M280.341,309.397c0,1.554-1.259,2.816-2.816,2.816c-1.554,0-2.813-1.263-2.813-2.816 s1.259-2.816,2.813-2.816C279.082,306.581,280.341,307.844,280.341,309.397z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#1B75BB",
    cx: 359.866,
    cy: 394.576,
    r: 2.816
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1B75BB",
    d: "M319.56,465.204c0,1.554-1.259,2.813-2.816,2.813c-1.554,0-2.816-1.259-2.816-2.813 c0-1.558,1.263-2.816,2.816-2.816C318.301,462.388,319.56,463.646,319.56,465.204z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1B75BB",
    d: "M312.38,278.556c0,1.554-1.263,2.813-2.816,2.813c-1.557,0-2.816-1.259-2.816-2.813 c0-1.558,1.26-2.816,2.816-2.816C311.117,275.739,312.38,276.998,312.38,278.556z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#1B75BB",
    cx: 276.531,
    cy: 495.573,
    r: 2.816
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#1B75BB",
    cx: 255.642,
    cy: 503.862,
    r: 5.509
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "none",
    stroke: "#1B75BB",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    points: " 256.417,200.385 256.417,606.129 162.151,580.941 78.904,498.354 53.546,403.259 78.264,306.242 177.325,219.932  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "none",
    stroke: "#1B75BB",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    points: " 256.417,267.067 256.417,539.445 319.698,522.536 375.581,467.097 392.607,403.259 376.011,338.132 309.513,280.192  "
  }), /*#__PURE__*/React.createElement("polyline", {
    fill: "none",
    stroke: "#1B75BB",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    points: " 276.495,599.099 305.779,593.091 307.653,565.313 317.791,562.308 336.563,584.082 369.6,563.436 359.837,535.279  369.225,530.024 393.247,541.661 415.021,514.633 399.255,492.858 404.135,484.224 434.544,486.102 445.806,453.44  421.029,437.674 422.907,428.664 452.188,420.025 451.063,385.865 421.779,379.108 421.029,370.474 445.431,349.074  434.544,318.665 403.01,322.42 400.008,314.16 416.149,289.384 393.626,262.73 366.594,274.742 361.336,269.112 367.347,240.956  336.938,224.814 315.164,243.958 308.032,240.956 306.904,213.928 276.87,205.668  "
  }), /*#__PURE__*/React.createElement("polyline", {
    fill: "none",
    stroke: "#1B75BB",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    points: " 277.524,309.397 291.724,313.302 292.251,326.077 295.628,327.496 305.918,318.446 320.295,326.077 317.453,339.388  319.938,342.048 332.714,336.371 343.36,348.969 335.73,360.682 337.152,364.586 352.057,362.811 357.202,377.184  345.667,387.299 346.024,391.382 359.866,394.576 360.397,410.725 346.556,414.804 345.667,419.065 357.381,426.518  352.057,441.956 337.684,441.068 335.377,445.151 342.829,455.441 332.539,468.217 321.179,462.719 316.743,465.204  321.357,478.511 305.743,488.271 296.868,477.979 292.076,479.398 291.192,492.531 277.347,495.369  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "none",
    stroke: "#1B75BB",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    points: " 255.296,200.385 194.129,303.277 184.235,399.328 193.303,499.914 256.417,606.129 134.355,497.439 78.904,498.354  112.094,402.625 256.788,403.451 78.264,306.242  "
  }), /*#__PURE__*/React.createElement("polyline", {
    fill: "none",
    stroke: "#1B75BB",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    points: " 78.264,306.242 194.129,303.277 256.788,308.16 52.422,405.1 253.902,504.583 134.355,497.439 256.788,403.451 177.325,219.932  112.094,402.625 133.664,497.785 162.151,580.941 255.296,505.303  "
  }), /*#__PURE__*/React.createElement("polyline", {
    fill: "none",
    stroke: "#1B75BB",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    points: " 278.063,205.995 275.513,236.914 305.842,213.633 276.495,221.452 308.032,240.956 315.164,243.958 367.347,240.956  327.718,232.918 361.336,269.112 336.938,224.814  "
  }), /*#__PURE__*/React.createElement("polyline", {
    fill: "none",
    stroke: "#1B75BB",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    points: " 366.594,274.742 416.149,289.384 387.178,267.067 408.956,300.424 376.51,270.335 400.008,314.16 403.01,322.42 421.029,370.474  434.544,318.665 415.601,320.619 445.431,349.074 406.012,322.063  "
  }), /*#__PURE__*/React.createElement("polyline", {
    fill: "none",
    stroke: "#1B75BB",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    points: " 421.779,379.108 452.188,420.025 451.063,385.865 436.985,424.513 422.907,428.664 436.985,382.616  "
  }), /*#__PURE__*/React.createElement("polyline", {
    fill: "none",
    stroke: "#1B75BB",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    points: " 421.029,437.674 434.544,486.102 445.806,453.44 421.029,485.269 430.45,443.667 404.135,484.224  "
  }), /*#__PURE__*/React.createElement("polyline", {
    fill: "none",
    stroke: "#1B75BB",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    points: " 399.255,492.858 408.669,522.521 383.201,536.793 408.669,505.856 369.225,530.024 359.837,535.279 336.563,584.082  366.765,555.26 327.925,574.068 317.791,562.308 360.397,536.895  "
  }), /*#__PURE__*/React.createElement("polyline", {
    fill: "none",
    stroke: "#1B75BB",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    points: " 305.779,593.091 273.85,590.733 278.689,599.099 307.653,565.313  "
  })), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#1B75BB",
    strokeMiterlimit: 10,
    d: "M76.976,491.112l-60.73,35.187 c-16.403,9.504-16.301,33.225,0.183,42.588l197.754,112.342c7.507,4.265,16.698,4.272,24.212,0.025L467.136,551.89 c7.619-4.308,16.956-4.231,24.507,0.196l101.396,93.606l343.617-0.054L1252.91,433.78c15.708-9.199,16.29-31.693,1.08-41.692 l-64.722-42.563c-15.152-9.963-14.643-32.353,0.949-41.616l115.297-68.511c15.359-9.126,16.142-31.067,1.474-41.263 l-101.025-70.221c-7.802-5.422-18.034-5.858-26.269-1.113L1063.2,193.911c-8.361,4.817-18.769,4.29-26.599-1.35l-90.063-64.835 c-7.937-5.713-18.499-6.172-26.901-1.176L721.625,244.398c-7.678,4.566-17.229,4.606-24.943,0.095L491.93,124.782 c-7.735-4.52-17.32-4.472-25.005,0.135l-159.74,95.681"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAboutSoftwareBg);
export default __webpack_public_path__ + "static/media/aboutSoftwareBg.15f844419b87095acdd7511adc1d74ea.svg";
export { ForwardRef as ReactComponent };